module.exports = __webpack_public_path__ + "img/au_gallery_1.32c7489c.jpg";